import { render, staticRenderFns } from "./BackupClientWorkspace.vue?vue&type=template&id=3d74bbc2&"
import script from "./BackupClientWorkspace.vue?vue&type=script&lang=js&"
export * from "./BackupClientWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports